var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import dayjs from "dayjs";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { Box, Divider, Tooltip } from "@mui/material";
export var GeneralMobileView = [{
        type: FormItemTypes.Typography,
        name: "ProductDetails",
        fontSize: "md",
        fontWeight: "strong",
        children: "Products Details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Supplier',
                        filedName: 'supplier'
                    }, {
                        label: 'Plant',
                        filedName: 'PlantCode',
                        secondFieldName: 'PlantName',
                        divider: true
                    }, {
                        label: 'Group',
                        filedName: 'ProductGroupCode',
                        secondFieldName: 'ProductGroupName',
                        divider: true
                    }, {
                        label: 'Product',
                        filedName: 'ModelCode',
                        secondFieldName: 'ModelName',
                        divider: true
                    }, {
                        label: 'Vehicle Manufacturing Date',
                        filedName: 'vehicleManufacturingDate'
                    }].map(function (item) {
                    return item.divider ? {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: true,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.filedName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: 'vertical',
                                        name: '',
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.secondFieldName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    } : {
                        type: FormItemTypes.Typography,
                        name: item.filedName,
                        label: item.label,
                        value: '-',
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        columnSize: 12,
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        containerProps: {
                            display: 'flex',
                            direction: 'row',
                            justifyContent: 'space-between'
                        },
                        valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-'; }
                    };
                }), true)
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "ProductDetails",
        fontSize: "md",
        fontWeight: "strong",
        children: "Repair Details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Branch',
                        filedName: 'BranchName'
                    }, {
                        label: 'Job Card Number',
                        filedName: 'JobCardNumber'
                    }, {
                        label: 'Part',
                        filedName: 'PartCode',
                        secondFieldName: 'PartName',
                        divider: true
                    }, {
                        label: 'KM Reading',
                        filedName: 'KMReading'
                    }, {
                        label: 'Repair Type',
                        filedName: 'RepairType'
                    }, {
                        label: 'Date Of Failure',
                        filedName: 'DateOfFailure',
                        date: true
                    }, {
                        label: 'Repair Date',
                        filedName: 'RepairDate',
                        date: true
                    }, {
                        label: 'Vendor Name',
                        filedName: 'VendorName'
                    }, {
                        label: 'Report Date',
                        filedName: 'ReportDate',
                        date: true
                    }, {
                        label: 'Reported By',
                        filedName: 'Reporter'
                    }, {
                        label: 'Reporter Mobile Number',
                        filedName: 'ReporterContact'
                    }, {
                        label: 'Parts Replaced',
                        filedName: 'PartsReplaced'
                    }, {
                        label: 'Vehicle Status After Repair',
                        filedName: 'VehicleStatusAfterRepair'
                    }].map(function (item) {
                    return item.divider ? {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: true,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.filedName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: 'vertical',
                                        name: '',
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.secondFieldName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    } : {
                        type: FormItemTypes.Typography,
                        name: item.filedName,
                        label: item.label,
                        value: '-',
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        columnSize: 12,
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        containerProps: {
                            display: 'flex',
                            direction: 'row',
                            justifyContent: 'space-between'
                        },
                        valueGetter: function (formValues, field) {
                            var _field$name, _field$name2;
                            return item !== null && item !== void 0 && item.date ? formValues !== null && formValues !== void 0 && formValues[(_field$name = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name !== void 0 ? _field$name : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name2 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name2 !== void 0 ? _field$name2 : '']).format('DD MMM, YYYY') : '-' : (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-';
                        }
                    };
                }), true)
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "title",
        fontSize: "md",
        fontWeight: "strong",
        children: "Customer Complaint",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Performance',
                        filedName: 'PerformanceCode',
                        secondFieldName: 'PerformanceName',
                        divider: true
                    }, {
                        label: 'Defect',
                        filedName: 'DefectCode',
                        secondFieldName: 'DefectName',
                        divider: true
                    }, {
                        label: 'Problem Description',
                        filedName: 'ProblemDescription'
                    }, {
                        label: 'Temperature Condition',
                        filedName: 'TemperatureConditionName'
                    }, {
                        label: 'Vehicale Speed',
                        filedName: 'VehicleSpeed'
                    }, {
                        label: 'Road Condition',
                        filedName: 'RoadCondition'
                    }].map(function (item) {
                    return item.divider ? {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        display: "flex",
                        justifyContent: "space-between",
                        columnSize: 12,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: '',
                                label: "".concat(item.label, " :"),
                                columnSize: 0,
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                }
                            }, {
                                type: FormItemTypes.ContainerItem,
                                name: '',
                                columnSize: true,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                spacing: 1,
                                elements: [{
                                        type: FormItemTypes.Typography,
                                        name: item.filedName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }, {
                                        type: FormItemTypes.Divider,
                                        orientation: 'vertical',
                                        name: '',
                                        columnSize: 0,
                                        containerProps: {
                                            height: "100%"
                                        }
                                    }, {
                                        type: FormItemTypes.Typography,
                                        name: item.secondFieldName,
                                        value: '-',
                                        fontWeight: "medium",
                                        columnSize: 0,
                                        fontSize: "sm"
                                    }]
                            }]
                    } : {
                        type: FormItemTypes.Typography,
                        name: item.filedName,
                        label: item.label,
                        value: '-',
                        fontSize: 'sm',
                        fontWeight: 'medium',
                        columnSize: 12,
                        labelTypographyProps: {
                            mb: 0,
                            noWrap: true,
                            fontWeight: 'medium',
                            fontSize: 'sm'
                        },
                        containerProps: {
                            display: 'flex',
                            direction: 'row',
                            justifyContent: 'space-between'
                        },
                        valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-'; }
                    };
                }), true)
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "title",
        fontSize: "md",
        fontWeight: "strong",
        children: "Customer Details",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Customer Name',
                        filedName: 'CustomerName'
                    }, {
                        label: 'Customer Email',
                        filedName: 'CustomerEmail'
                    }, {
                        label: 'Mobile Number',
                        filedName: 'mobileNumber'
                    }].map(function (item) { return ({
                    type: FormItemTypes.Typography,
                    name: item.filedName,
                    label: item.label,
                    value: '-',
                    fontSize: 'sm',
                    fontWeight: 'medium',
                    columnSize: 12,
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    containerProps: {
                        display: 'flex',
                        direction: 'row',
                        justifyContent: 'space-between'
                    },
                    valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-'; }
                }); }), true)
            }]
    }];
export var GeneralView = [{
        type: FormItemTypes.ContainerItem,
        name: "header",
        columnSize: 12,
        sx: {
            "& .css-1idn90j-MuiGrid-root": {
                pt: 1
            }
        },
        elements: [{
                type: FormItemTypes.Typography,
                name: "ProductDetails",
                fontSize: "md",
                fontWeight: "strong",
                children: "Product Details",
                columnSize: 12,
                sx: {
                    p: 0,
                    m: 0
                }
            }, {
                type: FormItemTypes.CardComponent,
                name: "",
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "",
                        columnSize: 12,
                        sx: {
                            pt: 0
                        },
                        elements: [{
                                type: FormItemTypes.ContainerItem,
                                name: "header",
                                columnSize: true,
                                sx: {
                                    border: 0
                                },
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: "Product details",
                                        label: "JC invoice return details",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: "supplier",
                                                label: "Supplier :",
                                                value: '-',
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "plantCode",
                                                label: "Plant :",
                                                value: '-',
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                display: "flex",
                                                justifyContent: "space-between",
                                                columnSize: 12,
                                                spacing: 0,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: '',
                                                        label: 'Group :',
                                                        columnSize: 0,
                                                        labelTypographyProps: {
                                                            mb: 0,
                                                            noWrap: true,
                                                            fontWeight: "medium",
                                                            fontSize: "sm"
                                                        }
                                                    }, {
                                                        type: FormItemTypes.ContainerItem,
                                                        name: '',
                                                        columnSize: true,
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        spacing: 1,
                                                        elements: [{
                                                                type: FormItemTypes.Typography,
                                                                name: 'ProductGroupCode',
                                                                fontWeight: "medium",
                                                                columnSize: 0,
                                                                fontSize: "sm"
                                                            }, {
                                                                type: FormItemTypes.Divider,
                                                                orientation: 'vertical',
                                                                name: '',
                                                                columnSize: 0,
                                                                containerProps: {
                                                                    height: "100%"
                                                                }
                                                            }, {
                                                                type: FormItemTypes.Typography,
                                                                name: 'ProductGroupName',
                                                                fontWeight: "medium",
                                                                columnSize: 0,
                                                                fontSize: "sm"
                                                            }]
                                                    }]
                                            }]
                                    }]
                            }, {
                                type: FormItemTypes.Divider,
                                name: "Divider",
                                orientation: "vertical",
                                columnSize: 0,
                                containerProps: {
                                    height: "100%"
                                }
                            }, {
                                type: FormItemTypes.Box,
                                name: "header",
                                columnSize: true,
                                sx: {
                                    border: 0
                                },
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: "productCodede",
                                        label: "Return invoice summary",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                display: "flex",
                                                justifyContent: "space-between",
                                                columnSize: 12,
                                                spacing: 0,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: '',
                                                        label: 'Product :',
                                                        columnSize: 0,
                                                        labelTypographyProps: {
                                                            mb: 0,
                                                            noWrap: true,
                                                            fontWeight: "medium",
                                                            fontSize: "sm"
                                                        }
                                                    }, {
                                                        type: FormItemTypes.ContainerItem,
                                                        name: '',
                                                        columnSize: true,
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        spacing: 1,
                                                        elements: [{
                                                                type: FormItemTypes.Typography,
                                                                name: 'ModelCode',
                                                                fontWeight: "medium",
                                                                columnSize: 0,
                                                                fontSize: "sm"
                                                            }, {
                                                                type: FormItemTypes.Divider,
                                                                orientation: 'vertical',
                                                                name: '',
                                                                columnSize: 0,
                                                                containerProps: {
                                                                    height: "100%"
                                                                }
                                                            }, {
                                                                type: FormItemTypes.Typography,
                                                                name: 'ModelName',
                                                                fontWeight: "medium",
                                                                columnSize: 0,
                                                                fontSize: "sm"
                                                            }]
                                                    }]
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "vehicleManufacturingDate:",
                                                label: "Vehicle Manufacturing Date:",
                                                value: '-',
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }]
                                    }]
                            }]
                    }]
            }, {
                type: FormItemTypes.Typography,
                name: "title",
                fontSize: "md",
                fontWeight: "strong",
                children: "Repair Details",
                columnSize: 12,
                sx: {
                    p: 0,
                    m: 0
                }
            }, {
                type: FormItemTypes.CardComponent,
                name: "",
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "",
                        columnSize: 12,
                        sx: {
                            pt: 0
                        },
                        elements: [{
                                type: FormItemTypes.Box,
                                name: "header",
                                columnSize: true,
                                sx: {
                                    border: 0
                                },
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: "Repair details",
                                        label: "",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: "BranchName",
                                                label: "Branch :",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "JobCardNumber",
                                                label: "Job Card Number:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                display: "flex",
                                                justifyContent: "space-between",
                                                columnSize: 12,
                                                spacing: 0,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: '',
                                                        label: 'Part :',
                                                        columnSize: 0,
                                                        labelTypographyProps: {
                                                            mb: 0,
                                                            noWrap: true,
                                                            fontWeight: "medium",
                                                            fontSize: "sm"
                                                        }
                                                    }, {
                                                        type: FormItemTypes.ContainerItem,
                                                        name: '',
                                                        columnSize: true,
                                                        display: 'flex',
                                                        justifyContent: 'flex-end',
                                                        spacing: 1,
                                                        elements: [{
                                                                type: FormItemTypes.Typography,
                                                                name: 'PartCode',
                                                                fontWeight: "medium",
                                                                columnSize: 0,
                                                                fontSize: "sm"
                                                            }, {
                                                                type: FormItemTypes.Divider,
                                                                orientation: 'vertical',
                                                                name: '',
                                                                columnSize: 0,
                                                                containerProps: {
                                                                    height: "100%"
                                                                }
                                                            }, {
                                                                type: FormItemTypes.Typography,
                                                                name: 'PartName',
                                                                fontWeight: "medium",
                                                                columnSize: 0,
                                                                fontSize: "sm"
                                                            }]
                                                    }]
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "KMReading",
                                                label: "KM Reading:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "RepairType",
                                                label: "Repair Type:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                datatype: "date",
                                                type: FormItemTypes.Typography,
                                                name: "DateOfFailure",
                                                label: "Date Of Failure:",
                                                valueGetter: function (formValues, field) {
                                                    var _field$name3, _field$name4;
                                                    return formValues !== null && formValues !== void 0 && formValues[(_field$name3 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name3 !== void 0 ? _field$name3 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name4 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name4 !== void 0 ? _field$name4 : '']).format('DD MMM, YYYY') : '-';
                                                },
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "RepairDate",
                                                label: "RepairDate",
                                                valueGetter: function (formValues, field) {
                                                    var _field$name5, _field$name6;
                                                    return formValues !== null && formValues !== void 0 && formValues[(_field$name5 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name5 !== void 0 ? _field$name5 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name6 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name6 !== void 0 ? _field$name6 : '']).format('DD MMM, YYYY') : '-';
                                                },
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }]
                                    }]
                            }, {
                                type: FormItemTypes.Divider,
                                name: "Divider",
                                orientation: "vertical",
                                columnSize: 0,
                                containerProps: {
                                    height: "100%"
                                }
                            }, {
                                type: FormItemTypes.Box,
                                name: "header",
                                columnSize: true,
                                sx: {
                                    border: 0
                                },
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: "repairDetails",
                                        label: "",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: "VendorName",
                                                label: "Vendor Name:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "ReportDate",
                                                label: "Report Date:",
                                                valueGetter: function (formValues, field) {
                                                    var _field$name7, _field$name8;
                                                    return formValues !== null && formValues !== void 0 && formValues[(_field$name7 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name7 !== void 0 ? _field$name7 : ''] ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues[(_field$name8 = field === null || field === void 0 ? void 0 : field.name) !== null && _field$name8 !== void 0 ? _field$name8 : '']).format('DD MMM, YYYY') : '-';
                                                },
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "Reporter",
                                                label: "Reported By:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "ReporterContact",
                                                label: "Reporter Mobile Number:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "PartsReplaced",
                                                label: "Parts Replaced:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "VehicleStatusAfterRepair",
                                                label: "Vehicle Status After Repair:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }]
                                    }]
                            }]
                    }]
            }, {
                type: FormItemTypes.Typography,
                name: "title",
                fontSize: "md",
                fontWeight: "strong",
                children: "Customer Complaint",
                columnSize: 12,
                sx: {
                    p: 0,
                    m: 0
                }
            }, {
                type: FormItemTypes.CardComponent,
                name: "",
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "",
                        columnSize: 12,
                        sx: {
                            pt: 0
                        },
                        elements: [{
                                type: FormItemTypes.Box,
                                name: "header",
                                columnSize: true,
                                sx: {
                                    border: 0
                                },
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: "",
                                        label: "",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                label: "Performance :",
                                                name: "",
                                                disabled: true,
                                                setFieldProps: function (formValues, currValue, field) {
                                                    return {
                                                        type: FormItemTypes.Typography,
                                                        children: /*#__PURE__*/ React.createElement(Box, {
                                                            sx: {
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 1,
                                                                fontSize: 'sm',
                                                                fontWeight: 'medium'
                                                            }
                                                        }, /*#__PURE__*/ React.createElement(Tooltip, {
                                                            title: formValues.PerformanceName || '-',
                                                            arrow: true
                                                        }, /*#__PURE__*/ React.createElement(Box, {
                                                            sx: {
                                                                whiteSpace: 'nowrap',
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                maxWidth: '100px' // adjust this value as needed
                                                            }
                                                        }, formValues.PerformanceName || '-')), /*#__PURE__*/ React.createElement(Divider, {
                                                            orientation: "vertical",
                                                            flexItem: true,
                                                            sx: {
                                                                borderColor: 'text.tertiary',
                                                                height: '16px',
                                                                alignSelf: 'center'
                                                            }
                                                        }), formValues.PerformanceCode || ''),
                                                        labelTypographyProps: {
                                                            mb: {
                                                                xs: '0px',
                                                                sm: '4px',
                                                                md: '4px'
                                                            },
                                                            noWrap: true,
                                                            fontWeight: 'medium',
                                                            fontSize: 'sm'
                                                        },
                                                        containerProps: {
                                                            display: 'flex',
                                                            direction: 'row',
                                                            justifyContent: 'space-between'
                                                        }
                                                    };
                                                },
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.ContainerItem,
                                                name: '',
                                                alignItems: 'center',
                                                columnSize: 12,
                                                spacing: 0,
                                                elements: [{
                                                        type: FormItemTypes.Typography,
                                                        name: '',
                                                        children: 'Defect:',
                                                        columnSize: 0,
                                                        noWrap: true,
                                                        fontWeight: "medium",
                                                        fontSize: "sm",
                                                        color: 'text.tertiary'
                                                    }, {
                                                        type: FormItemTypes.ContainerItem,
                                                        name: '',
                                                        columnSize: true,
                                                        justifyContent: 'flex-end',
                                                        spacing: 0,
                                                        columnGap: 1,
                                                        alignSelf: 'stretch',
                                                        elements: [{
                                                                type: FormItemTypes.Typography,
                                                                name: 'DefectName',
                                                                fontWeight: "medium",
                                                                columnSize: 0,
                                                                fontSize: "sm"
                                                            }, {
                                                                type: FormItemTypes.Divider,
                                                                orientation: 'vertical',
                                                                name: '',
                                                                columnSize: 0,
                                                                containerProps: {
                                                                    alignSelf: 'stretch'
                                                                }
                                                            }, {
                                                                type: FormItemTypes.Typography,
                                                                name: 'DefectCode',
                                                                fontWeight: "medium",
                                                                columnSize: 0,
                                                                fontSize: "sm"
                                                            }]
                                                    }]
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "ProblemDescription",
                                                label: "Problem Description:",
                                                value: "",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }]
                                    }]
                            }, {
                                type: FormItemTypes.Divider,
                                name: "Divider",
                                orientation: "vertical",
                                columnSize: 0,
                                containerProps: {
                                    height: "100%"
                                }
                            }, {
                                type: FormItemTypes.Box,
                                name: "header",
                                columnSize: true,
                                sx: {
                                    border: 0
                                },
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: "productCodede",
                                        label: "Return invoice summary",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: "TemperatureConditionName",
                                                label: "Temperature Condition:",
                                                value: "Dmeo",
                                                // value: '14 Dec, 2024 - 4:00 PM',
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "VehicleSpeed",
                                                label: "Vehicale Speed:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "RoadCondition",
                                                label: "Road Condition:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }]
                                    }]
                            }]
                    }]
            }, {
                type: FormItemTypes.Typography,
                name: "title",
                fontSize: "md",
                fontWeight: "strong",
                children: "Customer Details",
                columnSize: 12,
                sx: {
                    p: 0,
                    m: 0
                }
            }, {
                type: FormItemTypes.CardComponent,
                name: "",
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        name: "",
                        columnSize: 12,
                        sx: {
                            pt: 0
                        },
                        elements: [{
                                type: FormItemTypes.Box,
                                name: "header",
                                columnSize: true,
                                sx: {
                                    border: 0
                                },
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: "",
                                        label: "",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: "CustomerName",
                                                label: "Customer Name:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }, {
                                                type: FormItemTypes.Typography,
                                                name: "CustomerEmail",
                                                label: "Customer Email :",
                                                value: '',
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }]
                                    }]
                            }, {
                                type: FormItemTypes.Divider,
                                name: "Divider",
                                orientation: "vertical",
                                columnSize: 0,
                                containerProps: {
                                    height: "100%"
                                }
                            }, {
                                type: FormItemTypes.Box,
                                name: "header",
                                columnSize: true,
                                sx: {
                                    border: 0
                                },
                                elements: [{
                                        type: FormItemTypes.ContainerItem,
                                        name: "mobileNumber",
                                        label: "Mobile Number",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        columnSize: 12,
                                        spacing: 0,
                                        elements: [{
                                                type: FormItemTypes.Typography,
                                                name: "CustomerMobileNumber",
                                                label: "Mobile Number:",
                                                containerProps: {
                                                    display: "inline-flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "baseline",
                                                    gap: 1
                                                },
                                                labelTypographyProps: {
                                                    mb: 0,
                                                    noWrap: true,
                                                    fontWeight: "medium",
                                                    fontSize: "sm"
                                                },
                                                fontWeight: "medium",
                                                fontSize: "sm",
                                                columnSize: 12
                                            }]
                                    }]
                            }]
                    }]
            }]
    }];
